var React = require('react');

function Lightning (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#a)","key":0},React.createElement("path",{"d":"M13.5 1.5v8.75H21L11 24v-8.75H3.5l10-13.75Z","fill":"#EA650D"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"fill":"#fff","d":"M0 0h24v24H0z"})))]);
}

Lightning.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = Lightning;

Lightning.default = Lightning;
